// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__24Nbk","additionalInfo":"AgreementModal_additionalInfo__3ZlmB"};